<template>
  <layout-main-inner
    v-loading="loading"
    title="证书管理">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.certNo"
          clearable
          placeholder="请输入检验号"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="检验号"
          min-width="140"
          prop="certNo"></el-table-column>
        <el-table-column
          min-width="100"
          label="证书类型"
          prop="certTypeName"></el-table-column>
        <el-table-column
          min-width="100"
          label="检验结论"
          prop="conclusion"></el-table-column>
        <el-table-column
          min-width="100"
          label="质量/规格"
          prop="specifications"></el-table-column>
        <el-table-column
          min-width="100"
          label="放大检查"
          prop="magnifyingTest"></el-table-column>
        <el-table-column
          min-width="100"
          label="形状"
          prop="shape"></el-table-column>
        <el-table-column
          min-width="100"
          label="贵金属检查"
          prop="metalInspection"></el-table-column>
        <el-table-column
          min-width="100"
          label="备注"
          prop="remarks"></el-table-column>
        <el-table-column
          min-width="90"
          label="鉴定人"
          prop="appraiser"></el-table-column>
        <el-table-column
          min-width="90"
          label="批准人"
          prop="approver"></el-table-column>
        <el-table-column
          label="导入时间"
          fixed="right"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
export default {
  name: 'QualificationCertificateList',
  data() {
    return {
      uploadAccept: '',
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, certNo: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$$JewelsApi.getjewelscerts(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
